function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Mail_new_ic"
}, /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 152,
  height: 104,
  rx: 12,
  ry: 12
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.73 7.77L91.21 70.88a16.7 16.7 0 01-24.07 0L7.29 7.75",
  "data-name": "Cloud_download"
}));

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 112",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgMail;